export const SMALL_WIDTH_MODE_SIZE = 900 // ideally matches value in variables.scss Change from 900 to 200 when generating PDFs
export const MEDIUM_WIDTH_MODE_SIZE = 1200 // ideally matches value in variables.scss

export const useSmallWidthMode = () => {
  return window.innerWidth <= SMALL_WIDTH_MODE_SIZE
}
export const useMediumWidthMode = () => {
  return window.innerWidth <= MEDIUM_WIDTH_MODE_SIZE
}
